export const state = {
  showAlert: false,
  showAlertBanner: false,
  alertText: null,
};

export const getters = {};

export const mutations = {
  setShowAlert(state) {
    state.showAlert = !state.showAlert;
  },
  setShowAlertBanner(state, value) {
    state.showAlertBanner = value;
  },
  setAlertText(state, value) {
    state.alertText = value;
  },
};

export const actions = {};
